import { gql } from '@apollo/client';
import ORDER_FRAGMENT from 'graph/fragments/order';

const GET_MY_ACTIVE_ORDERS = gql`
  query getMyOrders($where: OrdersWhereInput!) {
    me {
      id
      orders(where: $where, orderBy: { field: DATE_CREATED, direction: DESC }) {
        ...OrderFragment
      }
    }
  }
  ${ORDER_FRAGMENT}
`;

export default GET_MY_ACTIVE_ORDERS;
